export class ProdutosCarrinho {
    public cabo: object = {};
    public satelite: object = {};
}